import { hit } from 'util/analytics'

export function trackSchoolPageHit(schoolId: number) {
  hit({ schoolId })
}
